import { Trans } from '@lingui/react/macro';
import React from 'react';
import { ChatQuota } from 'modules/chat/domain/interfaces';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';

interface ChatQuotaBarProps {
  quota?: ChatQuota;
}

const ChatQuotaBar: React.FC<ChatQuotaBarProps> = ({ quota }) => {
  if (!quota) {
    return null;
  }

  const { totalSpentTokens, remainingTokens, period } = quota;

  return (
    <UDText type="caption-1" color={theme.colors.Gray}>
      <Trans>
        Потрачено токенов: {totalSpentTokens} · Осталось: {remainingTokens} ({period})
      </Trans>
    </UDText>
  );
};

export default React.memo(ChatQuotaBar);
